/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceManagementAlertDashboardBlockComment'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceManagementAlertDashboardBlockComment'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceManagementAlertDashboardBlockCommentApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceManagementAlertDashboardBlockComment);
  }
}(this, function(ApiClient, PerformanceManagementAlertDashboardBlockComment) {
  'use strict';

  /**
   * PerformanceManagementAlertDashboardBlockComment service.
   * @module api/PerformanceManagementAlertDashboardBlockCommentApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceManagementAlertDashboardBlockCommentApi. 
   * @alias module:api/PerformanceManagementAlertDashboardBlockCommentApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceManagementAlertDashboardBlockCommentAddAllPut operation.
     * @callback module:api/PerformanceManagementAlertDashboardBlockCommentApi~performanceManagementAlertDashboardBlockCommentAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceManagementAlertDashboardBlockComment>} body 
     * @param {module:api/PerformanceManagementAlertDashboardBlockCommentApi~performanceManagementAlertDashboardBlockCommentAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceManagementAlertDashboardBlockCommentAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertDashboardBlockCommentAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertDashboardBlockCommentAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceManagementAlertDashboardBlockComment/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertDashboardBlockCommentEditAllPut operation.
     * @callback module:api/PerformanceManagementAlertDashboardBlockCommentApi~performanceManagementAlertDashboardBlockCommentEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceManagementAlertDashboardBlockComment>} body 
     * @param {module:api/PerformanceManagementAlertDashboardBlockCommentApi~performanceManagementAlertDashboardBlockCommentEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertDashboardBlockCommentEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertDashboardBlockCommentEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertDashboardBlockCommentEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlertDashboardBlockComment/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
